import { useDispatch, useSelector } from 'react-redux'
import {
  changeValue,
  selectActivePanel,
  selectDefaultTemplate,
  selectDetailPanel,
} from './store/slice'

const SettingPanel = ({ renderSettingPanel }) => {
  const dispatch = useDispatch()

  const activePanel = useSelector(selectActivePanel)
  const panel = useSelector(selectDetailPanel(activePanel))
  const defaultTemplate = useSelector(selectDefaultTemplate)

  const setValue = (key, value) => {
    dispatch(
      changeValue({
        id: panel?.id,
        key,
        value,
      }),
    )
  }

  return (
    <>
      {activePanel &&
        renderSettingPanel &&
        renderSettingPanel({
          panel,
          setValue,
          defaultPanel: defaultTemplate.panelById[panel?.id],
        })}
    </>
  )
}

export default SettingPanel
